import React, { createContext } from 'react';
import useVehicleDetails from '../../hooks/useVehicleDetails';
import { VehicleBag } from '../../types';

const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
const vehicleId = new URLSearchParams(locationSearch).get('vehicleId');
const market = new URLSearchParams(locationSearch).get('market');

interface VehicleProviderProps {
  children: React.ReactNode;
  oaddDealerId: string;
  isTier3?: boolean;
}

// This is injected to the application at root level, context will always have a value
export const vehicleContext = createContext<VehicleBag>({} as VehicleBag);
const { Provider } = vehicleContext;

const VehicleProvider: React.FC<VehicleProviderProps> = ({ children, oaddDealerId, isTier3 }) => {
  const vehicleInfo = useVehicleDetails(vehicleId, market, isTier3);
  const vehicleBag: VehicleBag = {
    ...vehicleInfo,
    oaddDealerId,
  };

  return <Provider value={vehicleBag}>{children}</Provider>;
};

export default VehicleProvider;
